var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gz-auth-view-template',{attrs:{"bc":false,"contentClass":"gz-auth-view-template__content_inner gz-form"}},[_c('Shelter',{attrs:{"slot":"content","single":true,"id":this.$route.params.id},slot:"content"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }